import React from "react";
import { ContentFooter, FooterContainer } from "./styles";

function Footer() {
    return(
        <FooterContainer>
        <ContentFooter>© built with dedication. By JLazaro</ContentFooter>
        </FooterContainer>
    )
}

export default Footer;